import styles from "./Accordion.module.scss";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Children, useState } from "react";
export default function Accordion({ label, children }) {
  const [isExpanded,setIsExpanded]= useState(false)
  function toggleButtonHandler(){
    setIsExpanded(!isExpanded);
  }
  return (
    <>
      <div className={styles.seperator}>
        <label htmlFor=""> {label}</label>
        <a onClick={toggleButtonHandler}>
         {!isExpanded && <FontAwesomeIcon icon={faChevronDown} />}
         {isExpanded && <FontAwesomeIcon icon={faChevronUp} />}
        </a>
      </div>
      <div>
      
    {children}
      </div>
    </>
  );
}
